import { ROUTE_START, ROUTE_POINTS, ORDERED_ROUTE_NODES } from "../data/routePoints";

export const SLUBKI = ROUTE_START;
export const FIXED_ROUTE_POINTS = ROUTE_POINTS;
export const FIXED_ROUTE_NODES = ORDERED_ROUTE_NODES;

function toRad(value) {
  return (value * Math.PI) / 180;
}

export function distanceMeters(a, b) {
  const R = 6371000;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);

  const s =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1) *
      Math.cos(lat2) *
      (Math.sin(dLng / 2) * Math.sin(dLng / 2));

  const c = 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
  return R * c;
}

export function formatDistance(meters) {
  if (!Number.isFinite(meters)) return "";
  if (meters < 1000) return `${Math.round(meters)} m`;
  return `${(meters / 1000).toFixed(2)} km`;
}